<mat-dialog-content>
  <img src="data:image/png;base64,{{ image }}" alt="doutor123" />
</mat-dialog-content>
